import React from 'react'
import { FormControl, FormLabel, Select } from '@chakra-ui/react'

export const ratingOptions = ['any', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

export default function RatingSelect({ label, value, onChange }) {
	return (
		<FormControl>
			<FormLabel fontSize="xs" fontWeight="600" color="gray.500" textTransform="uppercase" letterSpacing="0.05em" mb={1}>
				{label}
			</FormLabel>
			<Select size="sm" rounded="lg" value={value === null || value === undefined ? 'any' : value} onChange={onChange}>
				{ratingOptions.map((v) => (
					<option key={String(v)} value={v}>
						{v === 'any' ? 'Any' : v}
					</option>
				))}
			</Select>
		</FormControl>
	)
}
